import React from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ItineraryModal = ({ isOpen, onClose, content }) => {
  // const { closeModal } = useContext(SidebarContext);

  return (
    <Modal
      isOpen={isOpen}
      className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
      style={{ height: "80%" }}
      onClose={onClose}
    >
      <CommonCloseBtn onClose={onClose}/>
     <h2 className="justify-center text-center font-bold">ITINERARY DETAILS</h2>
      <ModalBody
        className="custom-modal"
        // style={{
        //   maxHeight: "40vh",
        //   minHeight: "200px",
        //   overflowY: "auto",
        //   paddingBottom: "30px",
        //   paddingLeft:"20px",
        //   paddingRight:"20px",
        //   paddingTop:"30px",
        //   scrollbarWidth: "thin",
        // }}
      >
        <div
            style={{
          maxHeight: "68vh",
          minHeight: "200px",
          overflowY: "auto",
          paddingBottom: "30px",
          paddingLeft:"20px",
          paddingRight:"20px",
          paddingTop:"30px",
          scrollbarWidth: "thin",
        
        }}
        
        dangerouslySetInnerHTML={{ __html: content }} />
      </ModalBody>
      {/* <div className="absolute bottom-0 left-0 w-full py-2 px-4 bg-gray-100 dark:bg-gray-700 border-t dark:border-gray-500 border-gray-200">
        <div className="flex justify-end">
          <Button
            layout="outline"
            onClick={onClose}
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          >
            Ok
          </Button>
        </div>
      </div> */}
    </Modal>
  );
};

export default ItineraryModal;
